// extracted by mini-css-extract-plugin
export default {"fondoOscuro":"CarruselMarcas_fondoOscuro__NQovJ","imagen-blanca":"CarruselMarcas_imagen-blanca__zrpGO","carrusel":"CarruselMarcas_carrusel__2EfoE"};